import svgPaths from "./svg-p1l0r5rnl8";

export default function Layer1() {
  return (
    <div className="relative size-full" data-name="Layer_1">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 35 35">
        <g clipPath="url(#clip0_154_1157)" id="Layer_1">
          <path d={svgPaths.pe82400} fill="var(--fill-0, #00B96F)" id="Vector" />
          <path d={svgPaths.p205ef5c0} fill="var(--fill-0, #00B96F)" id="Vector_2" />
        </g>
        <defs>
          <clipPath id="clip0_154_1157">
            <rect fill="white" height="35" width="35" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}